import { MultiCanvasService } from './../../../multi-canvas/multi-canvas.service';
import { ZStoreService } from './../../z-store.service';
import { map, tap } from 'rxjs/operators';
import { BoundingBox2FromCenterSize } from './../../share/boundingbox2';
import { EntityDragEvent } from './../../controls/mouse/mouse-entity.service';
import { Ng3MosueWheelEvent } from './../../controls/mouse/mouse-canvas.service';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  EntityModel,
  RingModel,
  Plane2Model,
} from './../../model';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Vector3, Vector2 } from 'three';
import { EntityStoreService } from '../../../entity-store/entity-store.service';

@Component({
  selector: 'ng3-tool-entity',
  templateUrl: './tool-entity.component.html',
  styleUrls: ['./tool-entity.component.css'],
})
export class ToolEntityComponent {
  private toolEntitySubject = new BehaviorSubject<EntityModel>(
    new RingModel(new Vector3(0, 0, 0), 29.9, 30),
  );
  toolModel$ = this.toolEntitySubject.asObservable();
  @Input()
  get model(): EntityModel {
    return this.toolEntitySubject.value;
  }
  set model(m: EntityModel) {
    this.toolEntitySubject.next(m);
  }
  @Output() drag = new EventEmitter<EntityDragEvent>();
  @Output() scroll = new EventEmitter<Ng3MosueWheelEvent>();

  // TODO: a public attribution: center should be added in type EntityModel
  plane$ = new Observable<Plane2Model>();
  z$ = new Observable<number>();
  private imageSubject = new BehaviorSubject<Plane2Model>(
    new Plane2Model(
      new BoundingBox2FromCenterSize(new Vector2(0, 0), new Vector2(200, 200)),
      // undefined,
      // new Vector3(0, 0, 0),
      // true,
      // 0.0,
      // true,
    ),
  );

  image$ = this.imageSubject.asObservable();
  constructor(
    private zStoreService: ZStoreService,
    private entityStoreService: EntityStoreService,
    private multiCanvasService: MultiCanvasService,
  ) {
    this.z$ = this.zStoreService.zToolEntityDrag$;
    // this.plane$ = this.toolModel$.pipe(
    //   map(m => {
    //     return new Plane2Model(
    //       new BoundingBox2FromCenterSize(
    //         new Vector2(0, 0),
    //         new Vector2(200, 200),
    //       ),
    //     );
    //   }),
    // );
    this.plane$ = this.image$.pipe(
      map(() => {
        return new Plane2Model(
          new BoundingBox2FromCenterSize(
            new Vector2(0, 0),
            new Vector2(200, 200),
          ),
        );
      }),
    );
    // this.ringModel$.pipe(map(ring => new RingModel(new Vector3(0, 0, 0), 29.9, 30))).subscribe(a => console.log(a));
    // this.toolModel$
    //   .pipe(
    //     map(toolModel => {
    //       switch (toolModel.type) {
    //         case 'ring':
    //           this.ringModel$.pipe(map(ring => toolModel));
    //           break;
    //         case 'line':
    //           this.lineModel$.pipe(map(line => toolModel));
    //           break;
    //       }
    //     }),
    //   )
    //   .subscribe(noop, console.error);
  }
  onWheelEvent(e: Ng3MosueWheelEvent) {
    this.scroll.emit(e);
  }
  onDragEvent(d: EntityDragEvent) {
    this.drag.emit(d);
    console.log('drag success');
  }
  dragRing(d: EntityDragEvent) {
    this.multiCanvasService.mapSelectedCanvas(c => {
      // const circleRadius = Math.sqrt(
      //   Math.pow(d.current.x - d.origin.x, 2) +
      //     Math.pow(d.current.y - d.origin.y, 2),
      // );
      this.entityStoreService.updateRingEntity({
        canvasId: c,
        model: new RingModel(
          new Vector3(d.origin.x, d.origin.y, 0),
          // circleRadius,
          // circleRadius + 0.001,
          Math.sqrt(
            Math.pow(d.current.x - d.origin.x, 2) +
              Math.pow(d.current.y - d.origin.y, 2),
          ),
          Math.sqrt(
            Math.pow(d.current.x - d.origin.x, 2) +
              Math.pow(d.current.y - d.origin.y, 2),
          ) + 0.001,
        ),
      });
    });
  }
  dragLine() {}
  dragCrossline(d: EntityDragEvent) {
    this.multiCanvasService.mapSelectedCanvas(c => {
      this.entityStoreService.crosslineOnCanvas(c, crossline => {
        let position: Vector3;
        switch (crossline.view) {
          case 'x':
            position = new Vector3(
              crossline.position.x,
              d.current.x,
              d.current.y,
            );
            break;
          case 'y':
            position = new Vector3(
              d.current.x,
              crossline.position.y,
              d.current.y,
            );
            break;
          case 'z':
            position = new Vector3(
              d.current.x,
              d.current.y,
              crossline.position.z,
            );
            break;
          default:
        }
        this.entityStoreService.updateCrosslines({
          model: {
            ...crossline,
            position: position,
          }
        })
        // this.entityStoreService.updateCrosslineEntity({
        //   canvasId: c,
        //   model: {
        //     ...crossline,
        //     position: position,
        //   },
        // });
      });
    });
  }
}
